import styled from "@emotion/styled";
import {Flex} from "antd";

export const Page = styled(Flex)`
  background-image: linear-gradient(to bottom, #003B7E , #0D6EFF);
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: 100%;
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  
//  radio input 
  & .ant-radio-group {
    width: 100%;
  }
  
  & .ant-radio-button-wrapper {
    width: 50%;
    text-align: center;
  }
`
